import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAmazondynamodbComponent } from './simple-icons-amazondynamodb.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAmazondynamodbComponent ],
    exports:      [ SimpleIconsAmazondynamodbComponent ],
    bootstrap:    []
})
export class SimpleIconsAmazondynamodbModule {}
